import {createContext, useContext} from 'react';

import {withContextBuilder} from '../../helpers/react/reactHelpers';
import {DataEventActionsEnum} from '../../models/tracking/dataEventActions';
import {AnyDataEventContext} from '../../models/tracking/dataEventContexts';
import {DataEventObjectName} from '../../models/tracking/dataEventObjectName';
import {logger} from '../logger/logger';

const dataEventLogger = logger.getLogger('data-event');
const defaultDataEventContext = {name: 'default'} as const;
export type DefaultEventContext = typeof defaultDataEventContext;

export type TrackDataEventObjectData = Record<string, unknown>;

export type TrackDataEvent = (
  action: DataEventActionsEnum,
  objectName: DataEventObjectName,
  objectData?: TrackDataEventObjectData,
) => void;

export interface DataEventTrackingContextType {
  context: AnyDataEventContext | DefaultEventContext;
  trackDataEvent: TrackDataEvent;
}

/*
 * Context.
 */

export const DataEventTrackingContext = createContext<DataEventTrackingContextType>({
  context: defaultDataEventContext,
  trackDataEvent: (action, objectName) => {
    dataEventLogger.warn('No data event tracking context available', {action, objectName});
  },
});

/*
 * Hook and HOC.
 */

export const useDataEventTracking = () => useContext(DataEventTrackingContext);
export const withDataEventTracking = withContextBuilder(DataEventTrackingContext);

/*
 * Type guards.
 */

export function isDataEventContext(
  context: AnyDataEventContext | DefaultEventContext,
): context is AnyDataEventContext {
  return context.name !== 'default';
}
